import EpisodePageBody from './EpisodePageBody';

export default EpisodePageBody;
